import {CartProduct} from "../types";

export function updateProductCartQuantity(
    products: CartProduct[],
    productId: number,
    quantity: number | string,
    setProducts: (products: CartProduct[]) => void
): void {
    products.map((product) => {
        if (product.id === productId){
            product.cartItemQuantity = quantity;
        }
    });

    setProducts(products);
}
